import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

interface CheckboxOptions {
  checkedValue: string;
  uncheckedValue: string;
}

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent {
  @Input()
  label: string = '';

  @Input()
  checkboxOptions: CheckboxOptions = { checkedValue: 'S', uncheckedValue: 'N' };

  value: boolean = false;

  private propagateChange = (_: any) => { };

  @Input()
  onChange?: (value: string) => void;

  constructor() { }

  change(checked: boolean) {
    this.value = checked;
    this.propagateChange(
      this.value ? this.checkboxOptions.checkedValue : this.checkboxOptions.uncheckedValue,
    );

    if (this.onChange) {
      this.onChange(this.value ? this.checkboxOptions.checkedValue : this.checkboxOptions.uncheckedValue);
    }
  }

  writeValue(param: string): void {
    this.value = (param === this.checkboxOptions.checkedValue);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;

    this.propagateChange(
      this.value ? this.checkboxOptions.checkedValue : this.checkboxOptions.uncheckedValue,
    );
  }

  registerOnTouched(fn: any): void { }

  setDisabledState?(isDisabled: boolean): void { }
}
